const $navLinks = document.querySelectorAll<HTMLAnchorElement>('.nav-link');
const $menuButton = document.querySelector<HTMLButtonElement>('.menu')!;

let $activeNavItem: HTMLAnchorElement | null = null;
let initialized = false;

$menuButton.onclick = () => {
    document.body.classList.toggle('has-menu');
    window.scrollTo(0, 0);
}

$navLinks.forEach(($navItem) => {
    $navItem.onclick = () => {
        document.body.classList.remove('has-menu');
    }
});

export default ($container: HTMLElement) => {
    const $link = $container.querySelector<HTMLAnchorElement>('.return');
    const href = $link ? $link.href : window.location.href;

    if ($activeNavItem) {
        $activeNavItem.classList.remove('active');
    }

    $navLinks.forEach(($navItem) => {
        if ($navItem.href === href) {
            $activeNavItem = $navItem;
            $activeNavItem.classList.add('active');
        }
    });

    if ($link && initialized) {
        $link.onclick = (event) => {
            event.preventDefault();
            history.back();
        }
    }

    document.body.classList.remove('has-menu');
    initialized = true;
}